import {
    SET_CELLPHONE_NUMBER_VALID,
    SET_CELLPHONE_NUMBER_VALUE,
    SET_FIRST_NAME_VALID,
    SET_FIRST_NAME_VALUE,
    SET_ID_NUMBER_VALID,
    SET_ID_NUMBER_VALUE,
    SET_SURNAME_VALID,
    SET_TOWN_VALUE,
    SET_TOWN_VALID,
    SET_SURNAME_VALUE,
    SET_EMPLOYMENT_STATUS_VALUE,
    SET_EMPLOYMENT_STATUS_VALID,
    SET_WAGE_FREQUENCY_VALUE,
    SET_WAGE_FREQUENCY_VALID,
    SET_PAYSLIP_VALID,
    SET_PAYSLIP_VALUE,
    SET_EMPLOYER_NAME_VALUE,
    SET_EMPLOYER_NAME_VALID,
    SET_CREDIT_CHECK_CONSENT_VALUE,
    SET_CREDIT_CHECK_CONSENT_VALID,
    SET_SIDEDRAWER_OPEN,
    FORM_VALID_PERSONAL_LOAN_FORM,
    FORM_INVALID_PERSONAL_LOAN_FORM,
    FORM_SUCCESS_TRANSITION_LEADS,
    FORM_SUBMITTING_TRANSITION_LEADS,
    FORM_ERROR_TRANSITION_LEADS,
    RESET_FORM,
} from '../../actions/publicWeb/naPersonalLoansCallMeBack';
import { API_CALL_STATUS, FIELD_STATUS, FORM_STATUS } from '../status';

const initial = {
    form: {
        firstName: { value: null, error: null, status: null },
        surname: { value: null, error: null, status: null },
        idNumber: { value: null, error: null, status: null },
        cellphoneNumber: { value: null, error: null, status: null },
        town: {
            value: null,
            error: "You'll need to select the town where you live or the nearest town to your location",
            status: FIELD_STATUS.ERROR,
        },
        employmentStatus: { value: null, error: null, status: null },
        wageFrequency: { value: null, error: null, status: null },
        payslip: { value: null, error: null, status: null },
        empoloyerName: { value: null, error: null, status: null },
        creditCheckConsent: { value: null, error: null, status: null },
    },
    isSidedrawerOpen: false,
    formStatus: FORM_STATUS.INVALID,
    leadServiceStatus: null,
};

export default (state = initial, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });

    switch (action.type) {
        case SET_FIRST_NAME_VALUE:
            return updateFormField('firstName', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_FIRST_NAME_VALID:
            return updateFormField('firstName', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));
        case SET_SURNAME_VALUE:
            return updateFormField('surname', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_SURNAME_VALID:
            return updateFormField('surname', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));
        case SET_ID_NUMBER_VALUE:
            return updateFormField('idNumber', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_ID_NUMBER_VALID:
            return updateFormField('idNumber', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));
        case SET_CELLPHONE_NUMBER_VALUE:
            return updateFormField('cellphoneNumber', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_CELLPHONE_NUMBER_VALID:
            return updateFormField('cellphoneNumber', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));
        case SET_TOWN_VALUE:
            return updateFormField('town', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_TOWN_VALID:
            return updateFormField('town', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));
        case SET_EMPLOYMENT_STATUS_VALUE:
            return updateFormField('employmentStatus', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_EMPLOYMENT_STATUS_VALID:
            return updateFormField('employmentStatus', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));
        case SET_WAGE_FREQUENCY_VALUE:
            return updateFormField('wageFrequency', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_WAGE_FREQUENCY_VALID:
            return updateFormField('wageFrequency', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));
        case SET_PAYSLIP_VALUE:
            return updateFormField('payslip', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_PAYSLIP_VALID:
            return updateFormField('payslip', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));
        case SET_EMPLOYER_NAME_VALUE:
            return updateFormField('employerName', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_EMPLOYER_NAME_VALID:
            return updateFormField('employerName', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));
        case SET_CREDIT_CHECK_CONSENT_VALUE:
            return updateFormField('creditCheckConsent', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_CREDIT_CHECK_CONSENT_VALID:
            return updateFormField('creditCheckConsent', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));
        case SET_SIDEDRAWER_OPEN:
            return {
                ...state,
                isSidedrawerOpen: action.value,
            };
        case FORM_VALID_PERSONAL_LOAN_FORM:
            return {
                ...state,
                formStatus: FORM_STATUS.VALID,
            };
        case FORM_INVALID_PERSONAL_LOAN_FORM:
            return {
                ...state,
                formStatus: FORM_STATUS.INVALID,
            };
        case FORM_SUCCESS_TRANSITION_LEADS:
            return {
                ...state,
                leadServiceStatus: API_CALL_STATUS.SUCCESS,
            };
        case FORM_SUBMITTING_TRANSITION_LEADS:
            return {
                ...state,
                leadServiceStatus: API_CALL_STATUS.PENDING,
            };
        case FORM_ERROR_TRANSITION_LEADS:
            return {
                ...state,
                leadServiceStatus: API_CALL_STATUS.FAILURE,
            };
        case RESET_FORM:
            return initial;
        default:
            return state;
    }
};
